
import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/clinicianSidebar";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import tmdbApi from "../api/tmdbApi";
import axios from 'axios';
import moment from "moment";
import SessionPopup from "./SessionPopup"
import Select from 'react-select';
import Loader from "../components/loader";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import deepZoom from "../assets/images/icons/Dna-dz.svg";

import DataTable from 'react-data-table-component';
import SideMenu from "./student/SideMenu";
import { v4 as uuid } from 'uuid';
let { lambda, country, appname } = window.app;

const EditTest = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [activeTab, setActiveTab] = useState("caseinfo");

    const [isLoading, setIsLoading] = useState(false);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [feeError, setEmailError] = useState('');


    console.log('idididid', id)
    const [pathrefnoError, setpathrefnoError] = useState('');
    const [pathrefdateError, setpathrefdateError] = useState('');
    const [biopsydateError, setbiopsydateError] = useState('');
    const [patientnameError, setpatientnameError] = useState('');
    const [ageError, setageError] = useState('');
    const [sexError, setsexError] = useState('');
    const [emailError, setemailError] = useState('');
    const [clinicianError, setclinicianError] = useState('');
    const [clinicregistrationnumberError, setclinicregistrationnumberError] = useState('');
    const [specimentypeError, setspecimentypeError] = useState('');
    const [siteofbiopsyError, setsiteofbiopsyError] = useState('');
    const [clinicalhistoryError, setclinicalhistoryError] = useState('');
    const [biopsyTypeError, setbiopsyTypeError] = useState('');


    const [testList, setTestList] = useState([])
    const [biopsyList, setBiopsyList] = useState([])
    const [selectedTests, setSelectedTests] = useState([]);
    const [selectedBiopsy, setSelectedBiopsy] = useState([]);
    const [showAdditional, setAdditionalTest] = useState(false);

    const [biopsyAPI, setbiopsyAPI] = useState(true);

    const [resourceBucket, setResourceImg] = useState(false);
    const [imageCloudfront, setimageCloudfront] = useState('');
    const [pdfFiles, setPdfFiles] = useState([])
    const [pdfUrls, setPdfUrls] = useState(null);
    const [pdfIndex, setPdfIndex] = useState(0)

    const [clinicalimageFiles, setclinicalImageFiles] = useState([])
    const [clinicalimagesUrls, setClinicalImageUrls] = useState(null);
    const [clinicalimageIndex, setClinicalImageIndex] = useState(0)
    const [fileSizeError, setFileSizeError] = useState(false);
    const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupImage, setPopupImage] = useState(null);
    const [deleteImage, setdeleteImage] = useState(false);
    const [deleteImageId, setDeleteImageId] = useState(null);
    const [deleteImageSuccess, setDeleteImageSuccess] = useState(false);
    const [deleteimageType, setImageType] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [patientIdUnique, setPatientIdUnique] = useState(false);

    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [editUser, setEditUser] = useState({
        "pathrefno": "",
        //"pathrefdate": "",
        "patientname": "",
        "age": "",
        //"sex": "",
        //"phone": "",
        //"email": "",
        //"clinician": "",
        "clinicregistrationnumber": "",
        "siteofbiopsy": "",
        "clinicalhistory": "",
        "specimentype": "",
    });
    const [formErrors, setFormErrors] = useState({});
    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        streetAddress1: '',
        streetAddress2: '',
        state: '',
        city: '',
        zipCode: '',
        phone: '',
        countryCode: 'IND'
    });
    const [permission, setPermission] = useState({});
    const [success, setSuccess] = useState(false);
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);
    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const [biopsyPathRef, setBiopsyRef] = useState(null)
    const [defaultBiopsyCost, setDefaultBiopsyCost] = useState("");
    const [defaultBiopsyTestName, setDefaultBiopsyTestName] = useState("");
    const userType = (localStorage.getItem("userType") || "").toLowerCase().trim();
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);

    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
        "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
        "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
        "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
        "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
    ];

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                    setimageCloudfront(window.site.common.imageCloudfront)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
            setimageCloudfront(window.site.common.imageCloudfront)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);


    console.log('editUser', editUser)


    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getuser();
        }

        getLookupInfo("Biopsy")
        getLookupInfo("Tests")
        getBiopsyRefNumber()

        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = id !== undefined ? path[path.length - 2] : path[path.length - 1];;
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

    const getLookupInfo = async (type) => {
        const response = await tmdbApi.lookupInfo(type);


        if (response?.result?.length > 0) {
            if (type == "Tests") {
                setTestList(response?.result)
            } else if (type == "Biopsy") {
                setBiopsyList(response?.result)
            }

        }
    }
    const getBiopsyRefNumber = async () => {
        const response = await tmdbApi.getBiopsyRefNumber();
        console.log('responsesss ', response)
        if (response?.result?.biopsyrefid) {
            // setBiopsyRef(response?.result)
            console.log('responsesss22 ', response?.result)
            setEditUser(prev => ({ ...prev, "pathrefno": response?.result?.biopsyrefid }));
        }
    }


    const getuser = (e) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/biopsyCaseInfo?appname=' + appname + '&patientid=' + id + '&token=' + token,
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                }
                else {
                    if (response?.data?.result.length > 0) {
                        setEditUser(response?.data?.result?.[0]);
                        setSelectedTests(response?.data?.result?.[0]?.tests)
                        setSelectedBiopsy(response?.data?.result?.[0]?.biopsyType)
                        if (response?.data?.result?.[0]?.defaultBiopsyTest?.cost !== undefined) {
                            setDefaultBiopsyCost(response?.data?.result?.[0]?.defaultBiopsyTest?.cost);
                        }
                        if (response?.data?.result?.[0]?.defaultBiopsyTest?.name !== undefined) {
                            setDefaultBiopsyTestName(response?.data?.result?.[0]?.defaultBiopsyTest?.name);
                        }
                        if (response?.data?.result?.[0] && response?.data?.result?.[0]?.permissions) {
                            setPermission(response?.data?.result?.[0]?.permissions)
                        }
                    } else {
                        setInvalidContent(true)
                    }
                }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/biopsy/cases')
    }

    // const getManagers = (e) => {
    //     GetTimeActivity()
    //     const token = localStorage.getItem("token")
    //     axios({
    //         method: 'GET',
    //         url: lambda + '/users?appname=' + appname + "&token=" + token + "&type=MANAGER",
    //     })
    //         .then(function (response) {
    //             console.log(response);
    //             setManagers(response?.data?.result)
    //         });
    // }



    // const getPermissions = (userType) => {
    //     GetTimeActivity()
    //     const token = localStorage.getItem("token")
    //     axios({
    //         method: 'GET',
    //         url: lambda + '/userPermissions?appname=' + appname + '&type=' + userType + "&token=" + token,
    //     })
    //         .then(function (response) {
    //             console.log("response?.data?.result?.data[0]", response?.data?.result?.data[0])
    //             if (response?.data?.result === "Invalid token or Expired") {
    //                 setShowSessionPopupup(true)
    //             } else {
    //                 setPermission(response?.data?.result?.data[0].permissions)
    //             }
    //         });
    // }

    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state

        setEditUser((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));

    };

    const columns = [

        {
            name: 'Name',
            selector: row => row?.name ?? "",
            sortable: true,
        },
        {
            name: 'Fee',
            selector: row => row?.fee ?? "",
            sortable: true,
        },

    ];


    // const handleChange = (e) => {
    //     console.log('typeeeeeeeeee', e.target.value)
    //     console.log('nameeeee', e.target.name)
    //     if (e.target.name === "userType") {
    //         if (id) {
    //             setCheckStatus(true);
    //         }
    //         // getPermissions(e.target.value);
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });

    //     } else if (e.target.name === "manager") {
    //         for (let key in manager) {
    //             if (manager.hasOwnProperty(key) && manager[key].userid === e.target.value) {
    //                 setEditUser({ ...editUser, [e.target.name]: e.target.value })
    //             }

    //         }

    //     } else if (e.target.name === "status") {
    //         if (id) {
    //             setCheckStatus(true);
    //         }
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });
    //     } else {
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });
    //     }



    // }

    const toggleAdditional = (e) => {
        setAdditionalTest(!showAdditional);
        setbiopsyAPI(false)
        if (biopsyAPI) {
            getLookupInfo("Tests")

        }
        // setActiveTab("tests")

    }

    const handleSelectChange = (selected) => {
        setSelectedTests(selected);
    }

    const handleBiopsyChange = (selected) => {
        setSelectedBiopsy(selected);
        setEditUser(prev => ({ ...prev, "biopsyType": selected }));
    }

    const handleChange = (e) => {
        const { name, value } = e.target;


        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleChangeMultiSelect = (selected, key) => {
        setEditUser({ ...editUser, [key]: selected });

    }
    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);
        if (!id) {
            navigate("/biopsy/cases")
        } else {

            navigate("/biopsy/cases/" + patientIdUnique + "/edit")
        }

    };

    const handleAddUser = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            createuser();
        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;
        // if (editUser?.emailid === undefined || editUser?.emailid?.trim() === "") {
        //     setEmailError("Please enter Email");
        //     setTimeout(function () { setEmailError("") }, 3000);
        //     formIsValid = false;
        // }
        // const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
        // if (regEx.test(editUser?.emailid)) {
        //     setEmailError("");
        //     setTimeout(function () { setEmailError("") }, 3000)
        // } else if (!regEx.test(editUser?.emailid) && editUser?.emailid !== "") {
        //     setEmailError("Please Enter Fee");
        //     setTimeout(function () { setEmailError("") }, 3000)
        //     formIsValid = false;
        // }

        if (editUser?.pathrefno === undefined || editUser?.pathrefno?.trim() === "") {
            setpathrefnoError("Please Enter Path Ref No");
            setTimeout(function () { setpathrefnoError("") }, 3000);
            formIsValid = false;
        }
        // if (editUser?.pathrefdate === undefined || editUser?.pathrefdate?.trim() === "") {
        //     setpathrefdateError("Please Enter Path Ref Date");
        //     setTimeout(function () { setpathrefdateError("") }, 3000);
        //     formIsValid = false;
        // }

        if (editUser?.biopsydate === undefined || editUser?.biopsydate?.trim() === "") {
            setbiopsydateError("Please Enter Biopsy Date");
            setTimeout(function () { setbiopsydateError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.patientname === undefined || editUser?.patientname?.trim() === "") {
            setpatientnameError("Please Enter Patient Name");
            setTimeout(function () { setpatientnameError("") }, 3000);
            formIsValid = false;
        }

        // if (editUser?.email === undefined || editUser?.email?.trim() === "") {
        //     setemailError("Please Enter Email");
        //     setTimeout(function () { setemailError("") }, 3000);
        //     formIsValid = false;
        // }

        if (editUser?.clinicregistrationnumber === undefined || editUser?.clinicregistrationnumber?.trim() === "") {
            setclinicregistrationnumberError("Please Enter Clinic Registration Number");
            setTimeout(function () { setclinicregistrationnumberError("") }, 3000);
            formIsValid = false;
        }

        //      if (editUser?.clinician === undefined || editUser?.clinician?.trim() === "") {
        // setclinicianError("Please Enter Clinician Name");
        //         setTimeout(function () { setclinicianError("") }, 3000);
        //         formIsValid = false;
        //     }

        if (editUser?.specimentype === undefined || editUser?.specimentype?.trim() === "") {
            setspecimentypeError("Please Enter Specimen Type");
            setTimeout(function () { setspecimentypeError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.siteofbiopsy === undefined || editUser?.siteofbiopsy?.trim() === "") {
            setsiteofbiopsyError("Please Enter Site of Biopsy");
            setTimeout(function () { setsiteofbiopsyError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.clinicalhistory === undefined || editUser?.clinicalhistory?.trim() === "") {
            setclinicalhistoryError("Please Enter Clinical History");
            setTimeout(function () { setclinicalhistoryError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.biopsyType === undefined || editUser?.biopsyType?.length == 0) {
            setbiopsyTypeError("Please Select Biopsy Types");
            setTimeout(function () { setbiopsyTypeError("") }, 3000);
            formIsValid = false;
        }

        // if (editUser?.fee === undefined || editUser?.fee?.trim() === "") {
        //     setEmailError("Please enter fee");
        //     setTimeout(function () { setEmailError("") }, 3000);
        //     formIsValid = false;
        // }

        // if (!editUser?.phoneNumber?.trim()) {
        //     setPhoneError("Enter phone number");
        //     setTimeout(() => setPhoneError(""), 3000);
        //     formIsValid = false;
        // }

        // if (editUser?.userType === "") {
        //     setTypeError("Please select Type");
        //     setTimeout(function () { setTypeError("") }, 3000);
        //     formIsValid = false;
        // }



        // if (editUser?.type === "ACCOUNTMANAGER" || editUser?.type === "CONTENTMANAGER" || editUser?.type === "MANAGER") {
        //     if (editUser?.manager === "" || editUser?.manager === undefined) {
        //         setManagerTypeError("Please select Manager");
        //         setTimeout(function () { setManagerTypeError("") }, 3000);
        //         formIsValid = false;
        //     }
        // }

        // console.log('editUser ', editUser)

        return formIsValid;
    }


    const handleSubmit = () => {
        GetTimeActivity()
        setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {

            // "userType": editUser?.userType,
            "pathrefno": editUser?.pathrefno,
            //  "pathrefdate": editUser?.pathrefdate,
            "biopsydate": editUser?.biopsydate,
            "patientname": editUser?.patientname,
            "age": editUser?.age,
            "gender": editUser?.gender,
            // "sex": editUser?.sex,
            // "phone": editUser?.phone,
            // "email": editUser?.email,
            "biopsyType": editUser?.biopsyType,
            // "clinician": editUser?.clinician,
            "clinicregistrationnumber": editUser?.clinicregistrationnumber,
            "siteofbiopsy": editUser?.siteofbiopsy,
            "clinicalhistory": editUser?.clinicalhistory,
            "specimentype": editUser?.specimentype,
            "caseType": editUser?.caseType || "Biopsy",
            "defaultBiopsyTest": {
                "name": defaultBiopsyTestName || "Biopsy Test",
                "cost": defaultBiopsyCost,
                "isDefault": true
            }

        }

        if (selectedTests && selectedTests?.length > 0) {
            payload["tests"] = selectedTests
        }

        if (selectedBiopsy && selectedBiopsy?.length > 0) {
            payload["biopsy"] = selectedBiopsy
        }

        axios({
            method: 'POST',
            url: lambda + '/updateBiopsyCase?appname=' + appname + '&patientid=' + id,
            data: payload,
        })
            .then(function (response) {
                if (response) {

                    if (clinicalimageFiles && clinicalimageFiles?.length > 0) {
                        handleFileUpload(clinicalimageFiles, id)
                    }

                    if (response?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response?.data?.result === "This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        setSuccess(true)
                        // setToastMessage("Updated Successfully")
                    }
                }

            });
    }


    const handleUpdate = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            handleSubmit();
        }
    }
    const createuser = async () => {
        setIsLoading(true)
        const patientid = uuid();
        setPatientIdUnique(patientid)
        // GetTimeActivity()   
        let payload = {}
        payload = {
            "pathrefno": editUser?.pathrefno,
            // "pathrefdate": editUser?.pathrefdate,
            "biopsydate": editUser?.biopsydate,
            "patientname": editUser?.patientname,
            "age": editUser?.age,
            "gender": editUser?.gender,
            // "phone": editUser?.phone,
            // "email": editUser?.email,
            //  "referringDoctor": editUser?.referringDoctor,
            "biopsyType": editUser?.biopsyType,
            "clinicregistrationnumber": editUser?.clinicregistrationnumber,
            "siteofbiopsy": editUser?.siteofbiopsy,
            "clinicalhistory": editUser?.clinicalhistory,
            "specimentype": editUser?.specimentype,
            "patientid": patientid,
            "caseType": (userType === "admin" || userType === "teaching admin") ? "Learning Case" : "Biopsy",
            "status": "Submitted",
            "createdby": localStorage.getItem("userId"),
            "defaultBiopsyTest": {
                "name": defaultBiopsyTestName || "Biopsy Test",
                "cost": defaultBiopsyCost,
                "isDefault": true
            }
        }
        if (selectedTests && selectedTests?.length > 0) {
            payload["tests"] = selectedTests
        }

        if (selectedBiopsy && selectedBiopsy?.length > 0) {
            payload["biopsy"] = selectedBiopsy
        }

        console.log('paylooo', payload)
        const token = localStorage.getItem("token")
        const userId = localStorage.getItem("userId")
        axios({
            method: 'POST',
            url: lambda + "/addBiopsyCase?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.result", response)

                    if (clinicalimageFiles && clinicalimageFiles?.length > 0) {
                        handleFileUpload(clinicalimageFiles, patientid)
                    }

                    if (response?.data?.result === "User already exists") {
                        setIsLoading(false)
                        setExistMsg(true)

                    }
                    else if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        // setToastMessage("Details Created Successfully")
                        // setTimeout(() => {
                        //     navigate("/biopsy"); // Trigger API call AFTER toast is displayed
                        // }, 2000);
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        if (id) {
            navigate({
                pathname: "/biopsy/cases",
                state: { search: true }
            });
        } else {
            navigate("/biopsy/cases")
        }
    }

    const CancelClick = () => {
        GetTimeActivity()
        setIsMsg(false);
        navigate("/biopsy/cases")
    }



    const handlePdfChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);

        Array.from(selectedFiles).map(async (file, index) => {
            // File size enable
            // let fileSize = 1048612 * 20 // 20MB

            if (pdfIndex > 0) {
                index = index + pdfIndex
            }
            let urlobj = URL.createObjectURL(file)

            setPdfFiles((prevData) => ([
                ...prevData, // Keep the other fields intact
                file
            ]));

            setPdfUrls((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["blob" + index]: {
                    url: urlobj,
                    name: file?.name
                }, // Update the changed field
            }));
            setPdfIndex(index + 1)


        })

    };

    const handlePdfDelete = (e, key) => {
        let imgUrls = { ...pdfUrls }
        let imgIndex = pdfIndex

        setPdfFiles(pdfFiles.filter(item => item.name !== imgUrls[key]?.name));
        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setPdfUrls(imgUrls)
        setPdfIndex(imgIndex - 1)

    }

    const handlePopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupImage(imageUrl)
    }

    const handleClinicalImageDelete = (e, key) => {
        let imgUrls = { ...clinicalimagesUrls }
        let imgIndex = clinicalimageIndex

        setclinicalImageFiles(clinicalimageFiles.filter(item => item.name !== imgUrls[key]?.name));
        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setClinicalImageUrls(imgUrls)
        setClinicalImageIndex(imgIndex - 1)

    }

    const handleimageFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        // console.log('ques', questionData?.files.length, imageFiles?.length, selectedFiles?.length)



        Array.from(selectedFiles).map(async (file, index) => {
            // File size enable
            let fileSize = 1048612 * 20 // 20MB
            if (file?.size < fileSize) {
                if (clinicalimageIndex > 0) {
                    index = index + clinicalimageIndex
                }
                console.log("index", index)
                let urlobj = URL.createObjectURL(file)
                let img = new Image();
                img.onload = function () {
                    setclinicalImageFiles((prevData) => ([
                        ...prevData, // Keep the other fields intact
                        file
                    ]));

                    setClinicalImageUrls((prevData) => ({
                        ...prevData, // Keep the other fields intact
                        ["blob" + index]: {
                            url: urlobj,
                            name: file?.name
                        }, // Update the changed field
                    }));
                    setClinicalImageIndex(index + 1)
                };
                img.src = urlobj;
            } else {
                setFileSizeError(true)
                setFileSizeErrorMsg("File size greater than 20MB")
            }


        })

    };

    const handleImageFileDelete = async (e, item, key, type) => {
        console.log("item ", item)
        // debugger
        setdeleteImage(true)
        let obj = item
        obj["index"] = key
        setDeleteImageId(item)
        setImageType(type)
    }
    const handleImageFileDeletes = async (e, item, key, type) => {
        console.log("item ", item)
        setdeleteImage(true)
        let obj = item
        obj["index"] = key
        setDeleteImageId(item)
        setImageType(type)
    }


    const imageFileDelete = async (e) => {
        setdeleteImage(false)
        try {
            let params = {
                "source_bucket": resourceBucket,
                "sourcepath": deleteImageId?.sourcepath,
                "fileid": deleteImageId?.fileid,
                "filename": deleteImageId?.filename
            }

            if (deleteimageType == "file") {
                await tmdbApi.deleteHistoricFiles(id, params);
            } else {
                await tmdbApi.deleteOmeFiles(id, params);
            }


            setDeleteImageSuccess(true)
        } catch {
            console.log("error");
        }
    }

    const onDelImageCancel = (e) => {
        setdeleteImage(false)
        setDeleteImageId(null)

    }

    const ondeleteImageConfirm = (e) => {
        setDeleteImageSuccess(false)
        let deleteImageIndex = deleteImageId["index"]
        if (deleteImageIndex > -1) { // only splice array when item is found
            editUser?.["historyfiles"]?.splice(deleteImageIndex, 1); // 2nd parameter means remove one item only
        }
        setDeleteImageId(null)
        let imgIndex = clinicalimageIndex
        setClinicalImageIndex(imgIndex - 1)
    }


    const handleFileUpload = async (files, biopsyid) => {
        // setUploadImg(true);
        console.log("files ", files)
        if (files && files.length > 0) {
            let filesArray = [];

            // Convert all file uploads into an array of promises
            const uploadPromises = Array.from(files).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                // const ObjectID = require("bson-objectid");
                //  const uniqueId = new ObjectID().toString();

                //  let uploadFilePath;
                let bucket;

                // if (file.type.startsWith('image/')) {
                let filenameReplace = file.name.replace(/ /g, "_");
                //uploadFilePath = `${appname}/${caseid}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                const ObjectID = require("bson-objectid");
                const uniqueId = new ObjectID().toString();
                const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;
                const uploadFilePath = `${appname}/${biopsyid}/${uniqueId}/${fileNameUnique}`;


                bucket = window.site && window.site.common && window.site.common.resourceBucket;

                const data = {
                    source_bucket: bucket,
                    sourcepath: uploadFilePath
                };

                const newFile = {
                    filename: filenameReplace.split('.')[0],
                    sourcepath: uploadFilePath,
                    fileid: uniqueId,
                    filetype: file.type,
                    filesize: file.size,
                    fileformat: fileExtension
                };

                filesArray.push(newFile);


                try {
                    // Get Upload URL
                    const uploadUrlResponse = await axios.post(
                        `${lambda}/uploadFiles?appname=${appname}&biopsyid=${biopsyid}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    );

                    if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                        const uploadUrl = uploadUrlResponse.data.result;

                        // Upload file to S3
                        const uploadResponse = await axios.put(uploadUrl, file, {
                            headers: {
                                'Content-Type': file.type,
                                'Cache-Control': 'no-cache'
                            }
                        });

                        if (uploadResponse.status === 200) {
                            return true; // Successfully uploaded
                        } else {
                            throw new Error('Failed to upload file to S3');
                        }
                    } else {
                        throw new Error('Failed to get upload URL');
                    }
                } catch (error) {
                    console.error('File upload error:', error);
                    return false;
                }
                // }
            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }
    };

    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
    };

    const amoutFrmt = (amount) => {
        const formattedAmount = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 2,
        }).format(amount);
        return formattedAmount;
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value }));
        validateForm()
    };

    const validateForm = () => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formValues.firstName.trim()) errors.firstName = 'First name is required';
        if (!formValues.lastName.trim()) errors.lastName = 'Last name is required';
        if (!emailRegex.test(formValues.email)) errors.email = 'Valid email is required';
        if (!formValues.streetAddress1.trim()) errors.streetAddress1 = 'Street address is required';
        if (!formValues.city.trim()) errors.city = 'City is required';
        if (!formValues.state.trim()) errors.state = 'State is required';
        if (!formValues.zipCode.match(/^\d{6}$/)) errors.zipCode = 'Zip code must be 6 digits';
        if (!formValues.phone.match(/^\d{10}$/)) errors.phone = 'Phone number must be 10 digits';

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const addPayment = async (params) => {
        let res = await tmdbApi.addPayment(params);
        console.log(res)
    }

    const handleBillingSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            // let parms = {
            //     "amount": plans[0].price,
            //     "paymentMethod": "card",
            //     "userid": localStorage.getItem("userId"),
            //     "planId": plans[0].subscriptionplanid,
            //     "description": plans[0].description
            // }
            // await addPayment(parms)
            console.log("Form submitted successfully", formValues);
        } else {
            console.log("Validation failed", formErrors);
        }
    };

    // console.log("editUser?.userData", userData);

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&

                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "ADD" : "EDIT "}</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>BIOPSY</span> / <b id="breadcrumb-action">{id === undefined ? "ADD " : "EDIT "}</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="create-quiz-btn border-0">
                                                    back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row table-data">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body cpc-management case-info edit-cpc">
                                                {!userData?.billingAddress && <p>Note : Please Update your Billing Address in your profile</p>}
                                                <ul className="nav nav-tabs nav-tabs-custom mb-4" role="tablist">
                                                    {/* <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${activeTab === "caseinfo" ? "active" : ""}`}
                                                            onClick={() => id && setActiveTab("caseinfo")}
                                                            role="tab"
                                                        >
                                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                            <span className="d-none d-sm-block">CASE INFO</span>
                                                        </button>
                                                    </li> */}
                                                    {/* <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${activeTab === "tests" ? "active" : ""}`}
                                                            onClick={() => id && setActiveTab("tests")}
                                                            role="tab"
                                                        >
                                                            <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                                            <span className="d-none d-sm-block">ADDITIONAL TESTS</span>
                                                        </button>
                                                    </li> */}
                                                    {/* <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${activeTab === "documents" ? "active" : ""}`}
                                                            onClick={() => id && setActiveTab("documents")}
                                                            role="tab"
                                                        >
                                                            <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                                            <span className="d-none d-sm-block">REPORTS</span>
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${activeTab === "photos" ? "active" : ""}`}
                                                            onClick={() => id && setActiveTab("photos")}
                                                            role="tab"
                                                        >
                                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                            <span className="d-none d-sm-block">PHOTOS</span>
                                                        </button>
                                                    </li> */}

                                                    {/* <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${activeTab === "payment" ? "active" : ""}`}
                                                            onClick={() => id && setActiveTab("payment")}
                                                            role="tab"
                                                        >
                                                            <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                                                            <span className="d-none d-sm-block">PAYMENT</span>
                                                        </button>
                                                    </li> */}
                                                </ul>

                                                {activeTab === "caseinfo" && (
                                                    <div className="create-user-block" id="create-user-block">
                                                        {Object.keys(editUser)?.length > 0 ? (
                                                            <>
                                                                <div className="form-block" id="form-block">
                                                                    <div className="row col-lg-12">



                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">PATH REF NO<span className="required">*</span></label>
                                                                                <input id="pathrefno" name="pathrefno" placeholder="Enter Path Ref No" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.pathrefno} />
                                                                                <span id="pathrefno-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{pathrefnoError}</span>
                                                                            </div>
                                                                        </div>

                                                                        {/* <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">PATH REF DATE<span className="required">*</span></label>
                                                                                <input id="pathrefdate" name="pathrefdate" placeholder="Enter Path Ref Date" type="date" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.pathrefdate} />
                                                                                <span id="pathrefdate-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{pathrefdateError}</span>
                                                                            </div>
                                                                        </div> */}

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">BIOPSY DATE<span className="required">*</span></label>
                                                                                <input id="biopsydate" name="biopsydate" placeholder="Enter Date" type="date" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.biopsydate} />
                                                                                <span id="biopsydate-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{biopsydateError}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">CLINIC REGISTRATION NUMBER<span className="required">*</span></label>
                                                                                <input id="clinicregistrationnumber" name="clinicregistrationnumber" placeholder="Enter Clinic Registration Number" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.clinicregistrationnumber} />
                                                                                <span id="clinicregistrationnumber-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{clinicregistrationnumberError}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">PATIENT NAME<span className="required">*</span></label>
                                                                                <input id="patientname" name="patientname" placeholder="Enter Patient Name" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.patientname} />
                                                                                <span id="patientname-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{patientnameError}</span>
                                                                            </div>
                                                                        </div>


                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">AGE<span className="required"></span></label>
                                                                                <input id="age" name="age" placeholder="Enter Age" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.age} />
                                                                                <span id="age-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{ageError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">GENDER<span className="required"></span></label>
                                                                                <select name="gender" className="form-control" onChange={(e) => handleChange(e)}>
                                                                                    <option value="">Select</option>
                                                                                    <option value="Male">Male</option>
                                                                                    <option value="Female">Female</option>
                                                                                </select>
                                                                                {/* <input id="gender" name="gender" placeholder="Enter Gender" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.gender} /> */}
                                                                                <span id="sex-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{sexError}</span>
                                                                            </div>
                                                                        </div>

                                                                        {/* <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">PHONE<span className="required"></span></label>
                                                                                <input id="phone" name="phone" placeholder="Enter Phone" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.phone} />
                                                                                <span id="phone-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{phoneError}</span>
                                                                            </div>
                                                                        </div> */}

                                                                        {/* <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">EMAIL<span className="required">*</span></label>
                                                                                <input id="email" name="email" placeholder="Enter Email" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.email} />
                                                                                <span id="email-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>
                                                                            </div>
                                                                        </div> */}

                                                                        {/* <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">REFERRING DOCTOR<span className="required"></span></label>
                                                                                <input id="referring-doctor" name="referringDoctor" placeholder="Enter Referring Doctor" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.referringDoctor} />
                                                                                <span id="clinician-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{clinicianError}</span>
                                                                            </div>
                                                                        </div> */}


                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">SPECIMEN TYPE<span className="required">*</span></label>
                                                                                <input id="specimentype" name="specimentype" placeholder="Enter Specimen Type" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.specimentype} />
                                                                                <span id="specimentype-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{specimentypeError}</span>
                                                                            </div>
                                                                        </div>


                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">SITE OF BIOPSY<span className="required">*</span></label>
                                                                                <input id="siteofbiopsy" name="siteofbiopsy" placeholder="Enter Site Of Biopsy" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.siteofbiopsy} />
                                                                                <span id="siteofbiopsy-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{siteofbiopsyError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">Biopsy Types<span className="required">*</span></label>

                                                                                {/* <Select
                                                                                    isMulti
                                                                                    placeholder={"Select"}
                                                                                    value={selectedTests}
                                                                                    onChange={handleSelectChange}

                                                                                    options={testList && testList.map((eachItem) => { return { value: eachItem.lookupcode, label: eachItem.name } })}
                                                                                    isClearable

                                                                                /> */}
                                                                                <Select
                                                                                    isMulti={false}
                                                                                    placeholder={"Select Biopsy Types"}
                                                                                    value={selectedBiopsy}
                                                                                    onChange={handleBiopsyChange}

                                                                                    options={biopsyList && biopsyList.map((eachItem) => { return { value: eachItem.lookupcode, label: eachItem.name } })}
                                                                                    isClearable

                                                                                />

                                                                                <span id="siteofbiopsy-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{biopsyTypeError}</span>

                                                                                {/* <select name="tests" onChange={(e) => handleChange(e)}
                                                                                    value={editUser?.tests} className="form-control form-select">
                                                                                    <option value="">Select</option>
                                                                                    {testList && testList?.length > 0 && testList?.map((task, i) => {
                                                                                        return (
                                                                                            <option key={i} value={task.lookupcode}>{task.name}</option>
                                                                                        )
                                                                                    }
                                                                                    )}
                                                                                </select> */}



                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">TESTS / SLIDES</label>
                                                                                <div className="table-responsive">
                                                                                    <table className="table table-bordered table-sm mb-0">
                                                                                        <thead className="table-light">
                                                                                            <tr>
                                                                                                <th>Test Name</th>
                                                                                                <th style={{ width: "180px" }}>Cost (₹)</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td>
                                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                                        <select
                                                                                                            className="form-control form-control-sm"
                                                                                                            value={defaultBiopsyTestName}
                                                                                                            onChange={(e) => setDefaultBiopsyTestName(e.target.value)}
                                                                                                        >
                                                                                                            <option value="">Select Test</option>
                                                                                                            {testList.map((item) => (
                                                                                                                <option key={item.lookupcode} value={item.name}>{item.name}</option>
                                                                                                            ))}
                                                                                                        </select>
                                                                                                        {/* <span className="badge" style={{ background: "#0d6efd", color: "#fff", fontSize: "10px", padding: "2px 6px", borderRadius: "3px", whiteSpace: "nowrap" }}>Default</span> */}
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <input
                                                                                                        type="number"
                                                                                                        className="form-control form-control-sm"
                                                                                                        placeholder="Enter cost"
                                                                                                        value={defaultBiopsyCost}
                                                                                                        onChange={(e) => setDefaultBiopsyCost(e.target.value)}
                                                                                                        min="0"
                                                                                                    />
                                                                                                </td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">CLINICAL HISTORY<span className="required">*</span></label>
                                                                                <textarea id="clinicalhistory" name="clinicalhistory" placeholder="Enter Clinical History" type="text" className="form-control edit-cpc-textarea" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.clinicalhistory} rows={5}
                                                                                    cols={5} >
                                                                                </textarea>
                                                                                <span id="clinicalhistory-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{clinicalhistoryError}</span>
                                                                            </div>
                                                                        </div>


                                                                        {/* <div className="col-lg-8 col-md-8 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <input type="checkbox" id="additional-tests" onChange={(e) => toggleAdditional(e)} />
                                                                                <label className="form_label">Additional Tests Required<span className="required"></span></label>

                                                                                {showAdditional && <DataTable
                                                                                    columns={columns}
                                                                                    data={testList}
                                                                                    pagination
                                                                                    highlightOnHover
                                                                                    striped
                                                                                    selectableRows={true} 
                                                                                    onSelectedRowsChange={handleRowSelected}
                                                                                    selectableRowsNoSelectAll
                                                                                />}


                                                                            </div>
                                                                        </div> */}






                                                                        <div className="col-md-12">
                                                                            <div className="d-flex col-lg-12 align-items-start justify-content-between">
                                                                                {/* <label className="form_label col-3">PHOTOS</label> */}
                                                                                <p className="mt-0 mb-0 text-muted col-8 file-format">Note: File size: 20 MB | Supported Formats: JPG, PNG</p>
                                                                            </div>

                                                                            <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-3">



                                                                                {/* Uploaded clinical images */}
                                                                                {/* THUMBNAIL GRID */}
                                                                                <div className="uploaded_images-grid mb-3 mt-2" /* grid container */>
                                                                                    {/* ── Clinical images from local upload ─────────────────── */}
                                                                                    <div className="upload-box">
                                                                                        <div className="file_upload add-box">
                                                                                            <input
                                                                                                type="file"
                                                                                                id="file-upload"
                                                                                                accept="image/jpeg, image/png"
                                                                                                className="file-input"
                                                                                                //multiple
                                                                                                onChange={handleimageFileChange}
                                                                                                style={{ display: "none" }}
                                                                                            />
                                                                                            <label htmlFor="file-upload" className="Add-btn d-flex align-items-center justify-content-center flex-column">
                                                                                                <p className="mb-0">
                                                                                                    <span className="material-symbols-outlined plus-icon">add</span>
                                                                                                </p>
                                                                                                ADD
                                                                                            </label>
                                                                                        </div>
                                                                                        {/* <div className="file_requirements mt-2 small text-muted">
                                                                                <p className="mb-1">File size: 20 MB</p>
                                                                                <p className="mb-0">Formats: JPG, PNG</p>
                                                                            </div> */}
                                                                                    </div>

                                                                                    {clinicalimagesUrls &&
                                                                                        Object.keys(clinicalimagesUrls).map((item, key) => (
                                                                                            <div className="thumb-box" key={key}>
                                                                                                <div
                                                                                                    className="thumb-img cursor-pointer"
                                                                                                    onClick={() => handlePopupImage(clinicalimagesUrls[item].url)}
                                                                                                >
                                                                                                    <img
                                                                                                        src={clinicalimagesUrls[item].url}
                                                                                                        alt="uploaded"
                                                                                                    />
                                                                                                </div>
                                                                                                <p className="thumb-name text-truncate small mb-0">
                                                                                                    {clinicalimagesUrls[item].name}
                                                                                                </p>
                                                                                            </div>
                                                                                        ))}



                                                                                    {/* ── Clinical images from editUser.historyfiles ─────────── */}
                                                                                    {editUser?.biopsyfiles?.length > 0 &&
                                                                                        editUser.biopsyfiles.map((item, key) => {
                                                                                            const imagePath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')
                                                                                                }?auto=compress,format`;
                                                                                            console.log('imagePath', imagePath)
                                                                                            return (
                                                                                                <div className="thumb-box" key={key}>
                                                                                                    <div
                                                                                                        className="thumb-img cursor-pointer"
                                                                                                        onClick={() => handlePopupImage(imagePath)}
                                                                                                    >
                                                                                                        <img src={`${imagePath}&width=150`} alt="history"
                                                                                                            onError={(e) => {
                                                                                                                e.currentTarget.onerror = null;
                                                                                                                e.currentTarget.src = deepZoom;
                                                                                                            }}
                                                                                                        />

                                                                                                    </div>
                                                                                                    {/* <p className="thumb-name text-truncate small mb-0">
                                                                                                        {item.filename}
                                                                                                    </p> */}
                                                                                                </div>
                                                                                            );
                                                                                        })}
                                                                                </div>

                                                                            </div>
                                                                        </div>

                                                                        {/* <div className="col-md-12" >
                                                            {clinicalimagesUrls &&
                                                                Object.keys(clinicalimagesUrls)?.length > 0 && <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="submit" onClick={e => handleFileUpload(clinicalimageFiles, id)}>Upload
                                                                </button>}
                                                        </div> */}


                                                                        <div className="row">
                                                                            <div className="col-md-12">
                                                                                <button id="submit-button" className="create-quiz-btn border-0" type="submit" onClick={e => id === undefined ? handleAddUser(e) : handleUpdate(e)}>

                                                                                    {id === undefined ? "Submit" : "Update"}
                                                                                </button>


                                                                            </div>
                                                                            {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                                                        </div>


                                                                        {/* Billing Summary and Upload Payment Receipt sections removed */}




                                                                    </div>
                                                                </div>

                                                                {/* <div className="row">
                                                                    <div className="col-md-12">
                                                                        <button id="submit-button" className="create-quiz-btn border-0" type="submit" onClick={e => id === undefined ? handleAddUser(e) : handleUpdate(e)}>

                                                                            {id === undefined ? "Submit" : "Update"}
                                                                        </button>

                                                                        {id && <button id="submit-button" className="create-quiz-btn border-0" type="submit" onClick={e => setActiveTab("tests")}>
                                                                            Next
                                                                        </button>}
                                                                    </div>
                                                                    {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                                                </div>
 */}


                                                            </>
                                                        ) : (
                                                            <div className="form-block" id="loading-block">
                                                                <div className="tab-content p-3 text-muted">
                                                                    <div className="tab-pane active show" id="home1" role="tabpanel">
                                                                        <div className="row">
                                                                            <Loader />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                {/* 
                                                {activeTab === "tests" &&
                                                    <div> Tests


                                                       

                                                        <div className="row">
                                                            <div className="col-md-12">

                                                                <button id="submit-button" className="create-quiz-btn border-0" type="submit" onClick={e => setActiveTab("caseinfo")}>
                                                                    Previous
                                                                </button>
                                                                <button id="submit-button" className="create-quiz-btn border-0" type="submit" onClick={e => setActiveTab("documents")}>
                                                                    Next
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                } */}




                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                }



                {showImagePopup && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.8)",
                            zIndex: 1003,
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "center",
                            padding: "20px", // padding all around
                        }}
                        onClick={() => setShowImagePopup(false)}
                    >
                        <div
                            style={{
                                position: "relative",
                                width: "auto",
                                height: "100%",
                                padding: "20px", // inner padding so image doesn't touch edges
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "start",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <img
                                src={popupImage}
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                    display: "block",
                                }}
                            />

                            <button
                                className="dz_close"
                                onClick={() => setShowImagePopup(false)}
                                style={{
                                    position: "absolute",
                                    top: 30,
                                    right: 30,
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                }}
                            >
                                <span className="material-symbols-outlined">close</span>
                            </button>
                        </div>
                    </div>


                )}
                <Footer id="footer" />
            </div>
            <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={id ? "Case Update Successfully" : "Case Created Successfully"}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert>
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <SweetAlert show={deleteImageSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Deleted Successfully"}
                onConfirm={e => ondeleteImageConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={deleteImage}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to delete?"
                focusCancelBtn
                onConfirm={e => imageFileDelete(e)}
                onCancel={e => onDelImageCancel(e)}
            >
            </SweetAlert>

            <SweetAlert show={fileSizeError}
                warning
                confirmBtnText="ok"
                confirmBtnBsStyle="danger"
                title={fileSizeErrorMsg}
                onConfirm={e => setFileSizeError(false)}
            >
            </SweetAlert>

        </>

    );
};

export default EditTest;
